import { IArea } from './areas'

export enum AreasModalOpenMode {
  Default = 'default',
  Openable = 'openable',
}

export type TMode = 'default' | 'openable'

export interface IAreasModal {
  areas: IArea[]
  selectedArea?: IArea
  mandatoryArea?: boolean
  onAreaSelected?: any
  loading?: boolean
  locale?: any
  onSetShowAreasModal?: any
  open?: boolean
  mode?: TMode
}
